// extracted by mini-css-extract-plugin
export var loopContainer = "logoLoop-module--loopContainer--961E2";
export var overlay = "logoLoop-module--overlay--9CHZ0";
export var logos = "logoLoop-module--logos--tseb-";
export var slide = "logoLoop-module--slide--kxwd4";
export var sm = "logoLoop-module--sm--1y0Cw";